import AOS from 'aos';

const defaultOptions = {
  duration: 650,
  once: true,
};

// Automatically initialize AOS on DOMContentLoaded
if (typeof window !== 'undefined') {
  window.AOS = AOS;

  window.addEventListener('DOMContentLoaded', () => {
    AOS.init(defaultOptions);
  });
}

// Export a function for custom initialization, if needed
export function initAOS(options = {}) {
  const aosOptions = { ...defaultOptions, ...options };
  AOS.init(aosOptions);
}
